// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.steps {
    background-color: white;
    /* filter: drop-shadow(4px 4px 5px rgb(230, 225, 225)); */
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.08), 0 0 6px rgba(0, 0, 0, 0.05);
    transition: 0.3s transform cubic-bezier(0.155, 1.105, 0.295, 1.12), 0.3s box-shadow;
    cursor: pointer;
    visibility: hidden;

    /* border-radius: 5px; */
}

/* .icons{
    visibility: hidden;
} */
.icons {
    visibility: hidden;
    position: relative;
}

.steps1 {
    animation: steps 1s linear alternate forwards;
    animation-delay: 0.25s;
}

.steps2 {
    animation: steps 1s linear alternate forwards;
    animation-delay: 0.5s;
}

.steps3 {
    animation: steps 1s ease-out alternate forwards;
    animation-delay: 0.75s;
}

.steps4 {
    animation: steps 1s ease-out alternate forwards;
    animation-delay: 1s;
}

.steps5 {
    animation: steps 1s ease-out alternate forwards;
    animation-delay: 1.25s;
}

.steps6 {
    animation: steps 1s ease-out alternate forwards;
    animation-delay: 1.5s;
}

.steps7 {
    animation: steps 1s ease-out alternate forwards;
    animation-delay: 1.75s;
}

.steps8 {
    animation: steps 1s ease-out alternate forwards;
    animation-delay: 2s;
}

.steps9 {
    animation: steps 1s ease-out alternate forwards;
    animation-delay: 2.25s;
}

.steps10 {
    animation: steps 1s ease-out alternate forwards;
    animation-delay: 2.5s;
}

.steps11 {
    animation: steps 1s ease-out alternate forwards;
    animation-delay: 2.75s;
}

.steps12 {
    animation: steps 1s ease-out alternate forwards;
    animation-delay: 3s;
}
.steps13 {
    animation: steps 1s ease-out alternate forwards;
    animation-delay: 3.25s;
}
.steps14 {
    animation: steps 1s ease-out alternate forwards;
    animation-delay: 3.5s;
}
.steps15 {
    animation: steps 1s ease-out alternate forwards;
    animation-delay: 3.75s;
}
.steps16 {
    animation: steps 1s ease-out alternate forwards;
    animation-delay: 4s;
}
.steps17 {
    animation: steps 1s ease-out alternate forwards;
    animation-delay: 4.25s;
}
.steps18 {
    animation: steps 1s ease-out alternate forwards;
    animation-delay: 4.5s;
}
.steps19 {
    animation: steps 1s ease-out alternate forwards;
    animation-delay: 4.75s;
}
.steps20 {
    animation: steps 1s ease-out alternate forwards;
    animation-delay: 5s;
}
.steps21 {
    animation: steps 1s ease-out alternate forwards;
    animation-delay: 5.25s;
}
.steps22 {
    animation: steps 1s ease-out alternate forwards;
    animation-delay: 5.5s;
}
.steps23 {
    animation: steps 1s ease-out alternate forwards;
    animation-delay: 5.75s;
}
.steps24 {
    animation: steps 1s ease-out alternate forwards;
    animation-delay: 6s;
}
.steps25 {
    animation: steps 1s ease-out alternate forwards;
    animation-delay: 6.25s;
}
.steps26 {
    animation: steps 1s ease-out alternate forwards;
    animation-delay: 6.5s;
}
.steps27 {
    animation: steps 1s ease-out alternate forwards;
    animation-delay: 6.75s;
}
.steps28 {
    animation: steps 1s ease-out alternate forwards;
    animation-delay: 7s;
}
.steps29 {
    animation: steps 1s ease-out alternate forwards;
    animation-delay: 7.25s;
}

.icons1 {
    animation: checks 1s linear alternate forwards;
    animation-delay: 3.5s;
}

.icons2 {
    animation: checks 1s linear alternate forwards;
    animation-delay: 4s;
}

.icons3 {
    animation: checks 1s ease-out alternate forwards;
    animation-delay: 4.5s;
}

.icons4 {
    animation: checks 1s ease-out alternate forwards;
    animation-delay: 5s;
}

.icons5 {
    animation: checks 1s ease-out alternate forwards;
    animation-delay: 5.5s;
}

.icons6 {
    animation: checks 1s ease-out alternate forwards;
    animation-delay: 6s;
}

.icons7 {
    animation: checks 1s ease-out alternate forwards;
    animation-delay: 6.5s;
}

.icons8 {
    animation: checks 1s ease-out alternate forwards;
    animation-delay: 7s;
}

.icons9 {
    animation: checks 1s ease-out alternate forwards;
    animation-delay: 7.5s;
}

.icons10 {
    animation: checks 1s ease-out alternate forwards;
    animation-delay: 8s;
}

.icons11 {
    animation: checks 1s ease-out alternate forwards;
    animation-delay: 8.5s;
}

.icons12 {
    animation: checks 1s ease-out alternate forwards;
    animation-delay: 9s;
}
.icons13 {
    animation: checks 1s ease-out alternate forwards;
    animation-delay: 9.5s;
}
.icons14 {
    animation: checks 1s ease-out alternate forwards;
    animation-delay: 10s;
}
.icons15 {
    animation: checks 1s ease-out alternate forwards;
    animation-delay: 10.5s;
}
.icons16 {
    animation: checks 1s ease-out alternate forwards;
    animation-delay: 11s;
}
.icons17 {
    animation: checks 1s ease-out alternate forwards;
    animation-delay: 11.5s;
}
.icons18 {
    animation: checks 1s ease-out alternate forwards;
    animation-delay: 12s;
}
.icons19 {
    animation: checks 1s ease-out alternate forwards;
    animation-delay: 12.5s;
}
.icons20 {
    animation: checks 1s ease-out alternate forwards;
    animation-delay: 13s;
}
.icons21 {
    animation: checks 1s ease-out alternate forwards;
    animation-delay: 13.5s;
}
.icons22 {
    animation: checks 1s ease-out alternate forwards;
    animation-delay: 14s;
}
.icons23 {
    animation: checks 1s ease-out alternate forwards;
    animation-delay: 14.5s;
}
.icons24 {
    animation: checks 1s ease-out alternate forwards;
    animation-delay: 15s;
}
.icons25 {
    animation: checks 1s ease-out alternate forwards;
    animation-delay: 15.5s;
}
.icons26 {
    animation: checks 1s ease-out alternate forwards;
    animation-delay: 16s;
}
.icons27 {
    animation: checks 1s ease-out alternate forwards;
    animation-delay: 16.5s;
}
.icons28 {
    animation: checks 1s ease-out alternate forwards;
    animation-delay: 17s;
}
.icons29 {
    animation: checks 1s ease-out alternate forwards;
    animation-delay: 17.5s;
}

.gif1 {
    visibility: hidden;
    animation: fadeIn 7s forwards 7s;
}

.gif2 {
    visibility: hidden;
    animation: fadeIn 8s forwards 8s;
}

.gif3 {
    visibility: hidden;
    animation: fadeIn 9s forwards 9s;
}

.gif4 {
    visibility: hidden;
    animation: fadeIn 10s forwards 10s;
}

.gif5 {
    visibility: hidden;
    animation: fadeIn 11s forwards 11s;
}

.gif6 {
    visibility: hidden;
    animation: fadeIn 12s forwards 12s;
}

.gif7 {
    display: none;
    animation-delay: 13s;
}

.gif8 {
    display: none;
    animation-delay: 14s;
}

.gif9 {
    display: none;
    animation-delay: 15s;
}

.gif10 {
    display: none;
    animation-delay: 16s;
}

.gif11 {
    display: none;
    animation-delay: 17s;
}

.gif12 {
    display: none;
    animation-delay: 18s;
}
.gif13 {
    display: none;
    animation-delay: 19s;
}
.gif14 {
    display: none;
    animation-delay: 20s;
}
.gif15 {
    display: none;
    animation-delay: 21s;
}
.gif16 {
    display: none;
    animation-delay: 22s;
}
.gif17 {
    display: none;
    animation-delay: 23s;
}
.gif18 {
    display: none;
    animation-delay: 24s;
}
.gif19 {
    display: none;
    animation-delay: 25s;
}
.gif20 {
    display: none;
    animation-delay: 26s;
}
.gif21 {
    display: none;
    animation-delay: 27s;
}
.gif22 {
    display: none;
    animation-delay: 28s;
}
.gif23 {
    display: none;
    animation-delay: 29s;
}
.gif24 {
    display: none;
    animation-delay: 30s;
}
.gif25 {
    display: none;
    animation-delay: 31s;
}
.gif26 {
    display: none;
    animation-delay: 32s;
}
.gif27 {
    display: none;
    animation-delay: 33s;
}
.gif28 {
    display: none;
    animation-delay: 34s;
}
.gif29 {
    display: none;
    animation-delay: 35s;
}

.scrut_loader1 {
    animation: scrut_loader 1s linear alternate forwards;
    animation-delay: 2.75s;
}

.scrut_loader2 {
    animation: scrut_loader 1s linear alternate forwards;
    animation-delay: 3.25s;
}

.scrut_loader3 {
    animation: scrut_loader 1s linear alternate forwards;
    animation-delay: 3.75s;
}

.scrut_loader4 {
    animation: scrut_loader 1s linear alternate forwards;
    animation-delay: 4.25s;
}

.scrut_loader5 {
    animation: scrut_loader 1s linear alternate forwards;
    animation-delay: 4.75s;
}

.scrut_loader6 {
    animation: scrut_loader 1s linear alternate forwards;
    animation-delay: 5.25s;
}

.scrut_loader7 {
    animation: scrut_loader 1s linear alternate forwards;
    animation-delay: 5.75s;
}

.scrut_loader8 {
    animation: scrut_loader 1s linear alternate forwards;
    animation-delay: 6.25s;
}

.scrut_loader9 {
    animation: scrut_loader 1s linear alternate forwards;
    animation-delay: 6.75s;
}

.scrut_loader10 {
    animation: scrut_loader 1s linear alternate forwards;
    animation-delay: 7.25s;
}

.scrut_loader11 {
    animation: scrut_loader 1s linear alternate forwards;
    animation-delay: 8.75s;
}

.scrut_loader12 {
    animation: scrut_loader 1s linear alternate forwards;
    animation-delay: 9.25s;
}
.scrut_loader13 {
    animation: scrut_loader 1s linear alternate forwards;
    animation-delay: 9.75s;
}
.scrut_loader14 {
    animation: scrut_loader 1s linear alternate forwards;
    animation-delay: 10.25s;
}
.scrut_loader15 {
    animation: scrut_loader 1s linear alternate forwards;
    animation-delay: 10.75s;
}
.scrut_loader16 {
    animation: scrut_loader 1s linear alternate forwards;
    animation-delay: 11.25s;
}
.scrut_loader17 {
    animation: scrut_loader 1s linear alternate forwards;
    animation-delay: 11.75s;
}
.scrut_loader18 {
    animation: scrut_loader 1s linear alternate forwards;
    animation-delay: 12.25s;
}
.scrut_loader19 {
    animation: scrut_loader 1s linear alternate forwards;
    animation-delay: 12.75s;
}
.scrut_loader20 {
    animation: scrut_loader 1s linear alternate forwards;
    animation-delay: 13.25s;
}
.scrut_loader21 {
    animation: scrut_loader 1s linear alternate forwards;
    animation-delay: 13.75s;
}
.scrut_loader22 {
    animation: scrut_loader 1s linear alternate forwards;
    animation-delay: 14.25s;
}
.scrut_loader23 {
    animation: scrut_loader 1s linear alternate forwards;
    animation-delay: 14.75s;
}
.scrut_loader24 {
    animation: scrut_loader 1s linear alternate forwards;
    animation-delay: 15.25s;
}
.scrut_loader25 {
    animation: scrut_loader 1s linear alternate forwards;
    animation-delay: 15.75s;
}
.scrut_loader26 {
    animation: scrut_loader 1s linear alternate forwards;
    animation-delay: 16.25s;
}
.scrut_loader27 {
    animation: scrut_loader 1s linear alternate forwards;
    animation-delay: 16.75s;
}
.scrut_loader28 {
    animation: scrut_loader 1s linear alternate forwards;
    animation-delay: 17.25s;
}
.scrut_loader29 {
    animation: scrut_loader 1s linear alternate forwards;
    animation-delay: 17.75s;
}

@keyframes checks {
    0% {
        opacity: 0;
        visibility: hidden;
    }

    50% {
        opacity: 1;
        visibility: visible;
    }

    100% {
        opacity: 1;
        visibility: visible;
    }
}

@keyframes steps {
    0% {
        opacity: 0;
        visibility: hidden;
    }

    50% {
        opacity: 1;
        visibility: visible;
    }

    100% {
        opacity: 1;
        visibility: visible;
    }
}

@keyframes scrut_loader {
    0% {
        visibility: visible;
        opacity: 0;
    }

    100% {
        visibility: hidden;
        opacity: 0;
        transition: all 0.5s linear;
    }
}
`, "",{"version":3,"sources":["webpack://./src/features/StepsForPopUp/Steps.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,yDAAyD;IACzD,uEAAuE;IACvE,mFAAmJ;IACnJ,eAAe;IACf,kBAAkB;;IAElB,wBAAwB;AAC5B;;AAEA;;GAEG;AACH;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,6CAA6C;IAC7C,sBAAsB;AAC1B;;AAEA;IACI,6CAA6C;IAC7C,qBAAqB;AACzB;;AAEA;IACI,+CAA+C;IAC/C,sBAAsB;AAC1B;;AAEA;IACI,+CAA+C;IAC/C,mBAAmB;AACvB;;AAEA;IACI,+CAA+C;IAC/C,sBAAsB;AAC1B;;AAEA;IACI,+CAA+C;IAC/C,qBAAqB;AACzB;;AAEA;IACI,+CAA+C;IAC/C,sBAAsB;AAC1B;;AAEA;IACI,+CAA+C;IAC/C,mBAAmB;AACvB;;AAEA;IACI,+CAA+C;IAC/C,sBAAsB;AAC1B;;AAEA;IACI,+CAA+C;IAC/C,qBAAqB;AACzB;;AAEA;IACI,+CAA+C;IAC/C,sBAAsB;AAC1B;;AAEA;IACI,+CAA+C;IAC/C,mBAAmB;AACvB;AACA;IACI,+CAA+C;IAC/C,sBAAsB;AAC1B;AACA;IACI,+CAA+C;IAC/C,qBAAqB;AACzB;AACA;IACI,+CAA+C;IAC/C,sBAAsB;AAC1B;AACA;IACI,+CAA+C;IAC/C,mBAAmB;AACvB;AACA;IACI,+CAA+C;IAC/C,sBAAsB;AAC1B;AACA;IACI,+CAA+C;IAC/C,qBAAqB;AACzB;AACA;IACI,+CAA+C;IAC/C,sBAAsB;AAC1B;AACA;IACI,+CAA+C;IAC/C,mBAAmB;AACvB;AACA;IACI,+CAA+C;IAC/C,sBAAsB;AAC1B;AACA;IACI,+CAA+C;IAC/C,qBAAqB;AACzB;AACA;IACI,+CAA+C;IAC/C,sBAAsB;AAC1B;AACA;IACI,+CAA+C;IAC/C,mBAAmB;AACvB;AACA;IACI,+CAA+C;IAC/C,sBAAsB;AAC1B;AACA;IACI,+CAA+C;IAC/C,qBAAqB;AACzB;AACA;IACI,+CAA+C;IAC/C,sBAAsB;AAC1B;AACA;IACI,+CAA+C;IAC/C,mBAAmB;AACvB;AACA;IACI,+CAA+C;IAC/C,sBAAsB;AAC1B;;AAEA;IACI,8CAA8C;IAC9C,qBAAqB;AACzB;;AAEA;IACI,8CAA8C;IAC9C,mBAAmB;AACvB;;AAEA;IACI,gDAAgD;IAChD,qBAAqB;AACzB;;AAEA;IACI,gDAAgD;IAChD,mBAAmB;AACvB;;AAEA;IACI,gDAAgD;IAChD,qBAAqB;AACzB;;AAEA;IACI,gDAAgD;IAChD,mBAAmB;AACvB;;AAEA;IACI,gDAAgD;IAChD,qBAAqB;AACzB;;AAEA;IACI,gDAAgD;IAChD,mBAAmB;AACvB;;AAEA;IACI,gDAAgD;IAChD,qBAAqB;AACzB;;AAEA;IACI,gDAAgD;IAChD,mBAAmB;AACvB;;AAEA;IACI,gDAAgD;IAChD,qBAAqB;AACzB;;AAEA;IACI,gDAAgD;IAChD,mBAAmB;AACvB;AACA;IACI,gDAAgD;IAChD,qBAAqB;AACzB;AACA;IACI,gDAAgD;IAChD,oBAAoB;AACxB;AACA;IACI,gDAAgD;IAChD,sBAAsB;AAC1B;AACA;IACI,gDAAgD;IAChD,oBAAoB;AACxB;AACA;IACI,gDAAgD;IAChD,sBAAsB;AAC1B;AACA;IACI,gDAAgD;IAChD,oBAAoB;AACxB;AACA;IACI,gDAAgD;IAChD,sBAAsB;AAC1B;AACA;IACI,gDAAgD;IAChD,oBAAoB;AACxB;AACA;IACI,gDAAgD;IAChD,sBAAsB;AAC1B;AACA;IACI,gDAAgD;IAChD,oBAAoB;AACxB;AACA;IACI,gDAAgD;IAChD,sBAAsB;AAC1B;AACA;IACI,gDAAgD;IAChD,oBAAoB;AACxB;AACA;IACI,gDAAgD;IAChD,sBAAsB;AAC1B;AACA;IACI,gDAAgD;IAChD,oBAAoB;AACxB;AACA;IACI,gDAAgD;IAChD,sBAAsB;AAC1B;AACA;IACI,gDAAgD;IAChD,oBAAoB;AACxB;AACA;IACI,gDAAgD;IAChD,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,oDAAoD;IACpD,sBAAsB;AAC1B;;AAEA;IACI,oDAAoD;IACpD,sBAAsB;AAC1B;;AAEA;IACI,oDAAoD;IACpD,sBAAsB;AAC1B;;AAEA;IACI,oDAAoD;IACpD,sBAAsB;AAC1B;;AAEA;IACI,oDAAoD;IACpD,sBAAsB;AAC1B;;AAEA;IACI,oDAAoD;IACpD,sBAAsB;AAC1B;;AAEA;IACI,oDAAoD;IACpD,sBAAsB;AAC1B;;AAEA;IACI,oDAAoD;IACpD,sBAAsB;AAC1B;;AAEA;IACI,oDAAoD;IACpD,sBAAsB;AAC1B;;AAEA;IACI,oDAAoD;IACpD,sBAAsB;AAC1B;;AAEA;IACI,oDAAoD;IACpD,sBAAsB;AAC1B;;AAEA;IACI,oDAAoD;IACpD,sBAAsB;AAC1B;AACA;IACI,oDAAoD;IACpD,sBAAsB;AAC1B;AACA;IACI,oDAAoD;IACpD,uBAAuB;AAC3B;AACA;IACI,oDAAoD;IACpD,uBAAuB;AAC3B;AACA;IACI,oDAAoD;IACpD,uBAAuB;AAC3B;AACA;IACI,oDAAoD;IACpD,uBAAuB;AAC3B;AACA;IACI,oDAAoD;IACpD,uBAAuB;AAC3B;AACA;IACI,oDAAoD;IACpD,uBAAuB;AAC3B;AACA;IACI,oDAAoD;IACpD,uBAAuB;AAC3B;AACA;IACI,oDAAoD;IACpD,uBAAuB;AAC3B;AACA;IACI,oDAAoD;IACpD,uBAAuB;AAC3B;AACA;IACI,oDAAoD;IACpD,uBAAuB;AAC3B;AACA;IACI,oDAAoD;IACpD,uBAAuB;AAC3B;AACA;IACI,oDAAoD;IACpD,uBAAuB;AAC3B;AACA;IACI,oDAAoD;IACpD,uBAAuB;AAC3B;AACA;IACI,oDAAoD;IACpD,uBAAuB;AAC3B;AACA;IACI,oDAAoD;IACpD,uBAAuB;AAC3B;AACA;IACI,oDAAoD;IACpD,uBAAuB;AAC3B;;AAEA;IACI;QACI,UAAU;QACV,kBAAkB;IACtB;;IAEA;QACI,UAAU;QACV,mBAAmB;IACvB;;IAEA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,kBAAkB;IACtB;;IAEA;QACI,UAAU;QACV,mBAAmB;IACvB;;IAEA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,2BAA2B;IAC/B;AACJ","sourcesContent":[".steps {\n    background-color: white;\n    /* filter: drop-shadow(4px 4px 5px rgb(230, 225, 225)); */\n    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.08), 0 0 6px rgba(0, 0, 0, 0.05);\n    transition: 0.3s transform cubic-bezier(0.155, 1.105, 0.295, 1.12), 0.3s box-shadow, 0.3s -webkit-transform cubic-bezier(0.155, 1.105, 0.295, 1.12);\n    cursor: pointer;\n    visibility: hidden;\n\n    /* border-radius: 5px; */\n}\n\n/* .icons{\n    visibility: hidden;\n} */\n.icons {\n    visibility: hidden;\n    position: relative;\n}\n\n.steps1 {\n    animation: steps 1s linear alternate forwards;\n    animation-delay: 0.25s;\n}\n\n.steps2 {\n    animation: steps 1s linear alternate forwards;\n    animation-delay: 0.5s;\n}\n\n.steps3 {\n    animation: steps 1s ease-out alternate forwards;\n    animation-delay: 0.75s;\n}\n\n.steps4 {\n    animation: steps 1s ease-out alternate forwards;\n    animation-delay: 1s;\n}\n\n.steps5 {\n    animation: steps 1s ease-out alternate forwards;\n    animation-delay: 1.25s;\n}\n\n.steps6 {\n    animation: steps 1s ease-out alternate forwards;\n    animation-delay: 1.5s;\n}\n\n.steps7 {\n    animation: steps 1s ease-out alternate forwards;\n    animation-delay: 1.75s;\n}\n\n.steps8 {\n    animation: steps 1s ease-out alternate forwards;\n    animation-delay: 2s;\n}\n\n.steps9 {\n    animation: steps 1s ease-out alternate forwards;\n    animation-delay: 2.25s;\n}\n\n.steps10 {\n    animation: steps 1s ease-out alternate forwards;\n    animation-delay: 2.5s;\n}\n\n.steps11 {\n    animation: steps 1s ease-out alternate forwards;\n    animation-delay: 2.75s;\n}\n\n.steps12 {\n    animation: steps 1s ease-out alternate forwards;\n    animation-delay: 3s;\n}\n.steps13 {\n    animation: steps 1s ease-out alternate forwards;\n    animation-delay: 3.25s;\n}\n.steps14 {\n    animation: steps 1s ease-out alternate forwards;\n    animation-delay: 3.5s;\n}\n.steps15 {\n    animation: steps 1s ease-out alternate forwards;\n    animation-delay: 3.75s;\n}\n.steps16 {\n    animation: steps 1s ease-out alternate forwards;\n    animation-delay: 4s;\n}\n.steps17 {\n    animation: steps 1s ease-out alternate forwards;\n    animation-delay: 4.25s;\n}\n.steps18 {\n    animation: steps 1s ease-out alternate forwards;\n    animation-delay: 4.5s;\n}\n.steps19 {\n    animation: steps 1s ease-out alternate forwards;\n    animation-delay: 4.75s;\n}\n.steps20 {\n    animation: steps 1s ease-out alternate forwards;\n    animation-delay: 5s;\n}\n.steps21 {\n    animation: steps 1s ease-out alternate forwards;\n    animation-delay: 5.25s;\n}\n.steps22 {\n    animation: steps 1s ease-out alternate forwards;\n    animation-delay: 5.5s;\n}\n.steps23 {\n    animation: steps 1s ease-out alternate forwards;\n    animation-delay: 5.75s;\n}\n.steps24 {\n    animation: steps 1s ease-out alternate forwards;\n    animation-delay: 6s;\n}\n.steps25 {\n    animation: steps 1s ease-out alternate forwards;\n    animation-delay: 6.25s;\n}\n.steps26 {\n    animation: steps 1s ease-out alternate forwards;\n    animation-delay: 6.5s;\n}\n.steps27 {\n    animation: steps 1s ease-out alternate forwards;\n    animation-delay: 6.75s;\n}\n.steps28 {\n    animation: steps 1s ease-out alternate forwards;\n    animation-delay: 7s;\n}\n.steps29 {\n    animation: steps 1s ease-out alternate forwards;\n    animation-delay: 7.25s;\n}\n\n.icons1 {\n    animation: checks 1s linear alternate forwards;\n    animation-delay: 3.5s;\n}\n\n.icons2 {\n    animation: checks 1s linear alternate forwards;\n    animation-delay: 4s;\n}\n\n.icons3 {\n    animation: checks 1s ease-out alternate forwards;\n    animation-delay: 4.5s;\n}\n\n.icons4 {\n    animation: checks 1s ease-out alternate forwards;\n    animation-delay: 5s;\n}\n\n.icons5 {\n    animation: checks 1s ease-out alternate forwards;\n    animation-delay: 5.5s;\n}\n\n.icons6 {\n    animation: checks 1s ease-out alternate forwards;\n    animation-delay: 6s;\n}\n\n.icons7 {\n    animation: checks 1s ease-out alternate forwards;\n    animation-delay: 6.5s;\n}\n\n.icons8 {\n    animation: checks 1s ease-out alternate forwards;\n    animation-delay: 7s;\n}\n\n.icons9 {\n    animation: checks 1s ease-out alternate forwards;\n    animation-delay: 7.5s;\n}\n\n.icons10 {\n    animation: checks 1s ease-out alternate forwards;\n    animation-delay: 8s;\n}\n\n.icons11 {\n    animation: checks 1s ease-out alternate forwards;\n    animation-delay: 8.5s;\n}\n\n.icons12 {\n    animation: checks 1s ease-out alternate forwards;\n    animation-delay: 9s;\n}\n.icons13 {\n    animation: checks 1s ease-out alternate forwards;\n    animation-delay: 9.5s;\n}\n.icons14 {\n    animation: checks 1s ease-out alternate forwards;\n    animation-delay: 10s;\n}\n.icons15 {\n    animation: checks 1s ease-out alternate forwards;\n    animation-delay: 10.5s;\n}\n.icons16 {\n    animation: checks 1s ease-out alternate forwards;\n    animation-delay: 11s;\n}\n.icons17 {\n    animation: checks 1s ease-out alternate forwards;\n    animation-delay: 11.5s;\n}\n.icons18 {\n    animation: checks 1s ease-out alternate forwards;\n    animation-delay: 12s;\n}\n.icons19 {\n    animation: checks 1s ease-out alternate forwards;\n    animation-delay: 12.5s;\n}\n.icons20 {\n    animation: checks 1s ease-out alternate forwards;\n    animation-delay: 13s;\n}\n.icons21 {\n    animation: checks 1s ease-out alternate forwards;\n    animation-delay: 13.5s;\n}\n.icons22 {\n    animation: checks 1s ease-out alternate forwards;\n    animation-delay: 14s;\n}\n.icons23 {\n    animation: checks 1s ease-out alternate forwards;\n    animation-delay: 14.5s;\n}\n.icons24 {\n    animation: checks 1s ease-out alternate forwards;\n    animation-delay: 15s;\n}\n.icons25 {\n    animation: checks 1s ease-out alternate forwards;\n    animation-delay: 15.5s;\n}\n.icons26 {\n    animation: checks 1s ease-out alternate forwards;\n    animation-delay: 16s;\n}\n.icons27 {\n    animation: checks 1s ease-out alternate forwards;\n    animation-delay: 16.5s;\n}\n.icons28 {\n    animation: checks 1s ease-out alternate forwards;\n    animation-delay: 17s;\n}\n.icons29 {\n    animation: checks 1s ease-out alternate forwards;\n    animation-delay: 17.5s;\n}\n\n.gif1 {\n    visibility: hidden;\n    animation: fadeIn 7s forwards 7s;\n}\n\n.gif2 {\n    visibility: hidden;\n    animation: fadeIn 8s forwards 8s;\n}\n\n.gif3 {\n    visibility: hidden;\n    animation: fadeIn 9s forwards 9s;\n}\n\n.gif4 {\n    visibility: hidden;\n    animation: fadeIn 10s forwards 10s;\n}\n\n.gif5 {\n    visibility: hidden;\n    animation: fadeIn 11s forwards 11s;\n}\n\n.gif6 {\n    visibility: hidden;\n    animation: fadeIn 12s forwards 12s;\n}\n\n.gif7 {\n    display: none;\n    animation-delay: 13s;\n}\n\n.gif8 {\n    display: none;\n    animation-delay: 14s;\n}\n\n.gif9 {\n    display: none;\n    animation-delay: 15s;\n}\n\n.gif10 {\n    display: none;\n    animation-delay: 16s;\n}\n\n.gif11 {\n    display: none;\n    animation-delay: 17s;\n}\n\n.gif12 {\n    display: none;\n    animation-delay: 18s;\n}\n.gif13 {\n    display: none;\n    animation-delay: 19s;\n}\n.gif14 {\n    display: none;\n    animation-delay: 20s;\n}\n.gif15 {\n    display: none;\n    animation-delay: 21s;\n}\n.gif16 {\n    display: none;\n    animation-delay: 22s;\n}\n.gif17 {\n    display: none;\n    animation-delay: 23s;\n}\n.gif18 {\n    display: none;\n    animation-delay: 24s;\n}\n.gif19 {\n    display: none;\n    animation-delay: 25s;\n}\n.gif20 {\n    display: none;\n    animation-delay: 26s;\n}\n.gif21 {\n    display: none;\n    animation-delay: 27s;\n}\n.gif22 {\n    display: none;\n    animation-delay: 28s;\n}\n.gif23 {\n    display: none;\n    animation-delay: 29s;\n}\n.gif24 {\n    display: none;\n    animation-delay: 30s;\n}\n.gif25 {\n    display: none;\n    animation-delay: 31s;\n}\n.gif26 {\n    display: none;\n    animation-delay: 32s;\n}\n.gif27 {\n    display: none;\n    animation-delay: 33s;\n}\n.gif28 {\n    display: none;\n    animation-delay: 34s;\n}\n.gif29 {\n    display: none;\n    animation-delay: 35s;\n}\n\n.scrut_loader1 {\n    animation: scrut_loader 1s linear alternate forwards;\n    animation-delay: 2.75s;\n}\n\n.scrut_loader2 {\n    animation: scrut_loader 1s linear alternate forwards;\n    animation-delay: 3.25s;\n}\n\n.scrut_loader3 {\n    animation: scrut_loader 1s linear alternate forwards;\n    animation-delay: 3.75s;\n}\n\n.scrut_loader4 {\n    animation: scrut_loader 1s linear alternate forwards;\n    animation-delay: 4.25s;\n}\n\n.scrut_loader5 {\n    animation: scrut_loader 1s linear alternate forwards;\n    animation-delay: 4.75s;\n}\n\n.scrut_loader6 {\n    animation: scrut_loader 1s linear alternate forwards;\n    animation-delay: 5.25s;\n}\n\n.scrut_loader7 {\n    animation: scrut_loader 1s linear alternate forwards;\n    animation-delay: 5.75s;\n}\n\n.scrut_loader8 {\n    animation: scrut_loader 1s linear alternate forwards;\n    animation-delay: 6.25s;\n}\n\n.scrut_loader9 {\n    animation: scrut_loader 1s linear alternate forwards;\n    animation-delay: 6.75s;\n}\n\n.scrut_loader10 {\n    animation: scrut_loader 1s linear alternate forwards;\n    animation-delay: 7.25s;\n}\n\n.scrut_loader11 {\n    animation: scrut_loader 1s linear alternate forwards;\n    animation-delay: 8.75s;\n}\n\n.scrut_loader12 {\n    animation: scrut_loader 1s linear alternate forwards;\n    animation-delay: 9.25s;\n}\n.scrut_loader13 {\n    animation: scrut_loader 1s linear alternate forwards;\n    animation-delay: 9.75s;\n}\n.scrut_loader14 {\n    animation: scrut_loader 1s linear alternate forwards;\n    animation-delay: 10.25s;\n}\n.scrut_loader15 {\n    animation: scrut_loader 1s linear alternate forwards;\n    animation-delay: 10.75s;\n}\n.scrut_loader16 {\n    animation: scrut_loader 1s linear alternate forwards;\n    animation-delay: 11.25s;\n}\n.scrut_loader17 {\n    animation: scrut_loader 1s linear alternate forwards;\n    animation-delay: 11.75s;\n}\n.scrut_loader18 {\n    animation: scrut_loader 1s linear alternate forwards;\n    animation-delay: 12.25s;\n}\n.scrut_loader19 {\n    animation: scrut_loader 1s linear alternate forwards;\n    animation-delay: 12.75s;\n}\n.scrut_loader20 {\n    animation: scrut_loader 1s linear alternate forwards;\n    animation-delay: 13.25s;\n}\n.scrut_loader21 {\n    animation: scrut_loader 1s linear alternate forwards;\n    animation-delay: 13.75s;\n}\n.scrut_loader22 {\n    animation: scrut_loader 1s linear alternate forwards;\n    animation-delay: 14.25s;\n}\n.scrut_loader23 {\n    animation: scrut_loader 1s linear alternate forwards;\n    animation-delay: 14.75s;\n}\n.scrut_loader24 {\n    animation: scrut_loader 1s linear alternate forwards;\n    animation-delay: 15.25s;\n}\n.scrut_loader25 {\n    animation: scrut_loader 1s linear alternate forwards;\n    animation-delay: 15.75s;\n}\n.scrut_loader26 {\n    animation: scrut_loader 1s linear alternate forwards;\n    animation-delay: 16.25s;\n}\n.scrut_loader27 {\n    animation: scrut_loader 1s linear alternate forwards;\n    animation-delay: 16.75s;\n}\n.scrut_loader28 {\n    animation: scrut_loader 1s linear alternate forwards;\n    animation-delay: 17.25s;\n}\n.scrut_loader29 {\n    animation: scrut_loader 1s linear alternate forwards;\n    animation-delay: 17.75s;\n}\n\n@keyframes checks {\n    0% {\n        opacity: 0;\n        visibility: hidden;\n    }\n\n    50% {\n        opacity: 1;\n        visibility: visible;\n    }\n\n    100% {\n        opacity: 1;\n        visibility: visible;\n    }\n}\n\n@keyframes steps {\n    0% {\n        opacity: 0;\n        visibility: hidden;\n    }\n\n    50% {\n        opacity: 1;\n        visibility: visible;\n    }\n\n    100% {\n        opacity: 1;\n        visibility: visible;\n    }\n}\n\n@keyframes scrut_loader {\n    0% {\n        visibility: visible;\n        opacity: 0;\n    }\n\n    100% {\n        visibility: hidden;\n        opacity: 0;\n        transition: all 0.5s linear;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
